export enum Roles {
  AppUser = 'AppUser',
  Admin = 'Admin',
  Agency = 'Agency',
  SosOffice = 'SOS Office',
  AgSup = 'AG Sup.',
  AgRev = 'AG Reviewer',
  GovSup = "GOV's Sup.",
  GovRev = "GOV's Reviewer",
}
